import styled from "styled-components";
import { Modal as Base } from "@sablier/v2-components/organisms";
import { tags } from "@sablier/v2-constants";
import { _ } from "@sablier/v2-mixins";
import { useModalTransaction } from "~/client/hooks";
import Body from "./Body";

const Modal = styled(Base.Card)`
  div[data-component="modal-card"] {
    max-width: 600px;
  }
`;

const Wrapper = styled.div`
  flex: 1;
  flex-shrink: 0;
  width: 100%;
`;

function Transaction() {
  const { data, id: modalId } = useModalTransaction();

  return (
    <Modal
      id={modalId}
      isBackdropDisabled
      isCloseDisabled={!!data.isNotClosable}
      title={data.title}
      elevation={40}
    >
      <Wrapper data-cy={tags.modalTransaction}>
        <Body />
      </Wrapper>
    </Modal>
  );
}

export default Transaction;
